export const ROUTES = {
    PRODUCT_MAIN: "/products",
    PRODUCT_DETAILS:  "/products/:product+/details/:api",
    HOME: "/",
    LOGIN: "/login",
    REGISTER: "/register",
    USER_PROFILE: "/userprofile",
    CONTACT_US: "/contactus",
    SUPPORT_FAQS: "/faqs",
    THANK_YOU_FOR_REGISTRATION: "/thankyouregistration",
    EMAIL_VERIFIED: "/emailverified",
    FORGOT_PASSWORD: "/forgotpassword",
    ACCOUNT_SETTINGS: "/accountsettings",
    GETTING_STARTED: "/gettingstarted"

}
